import React, {useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const StyledRating = withStyles({
    iconFilled: {
        color: '#666',
    }
})(Rating);

export const CustomizedRatings = ({selected = 1, disabled=false, readOnly, name, max=5}) => {
    const [value, setValue] = useState();
    return (
        <div>
            <StyledRating
                name={name}
                defaultValue={selected}
                precision={0.5}
                emptyIcon={<StarBorderIcon fontSize="inherit"/>}
                readOnly={readOnly}
                disabled={disabled}
                value={value}
                max={max}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
            />
        </div>
    );
}